// src/index.js
import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { BrowserRouter } from 'react-router-dom';
import { ParallaxProvider } from "react-scroll-parallax";
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async'; 
import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports';
import '@aws-amplify/ui-react/styles.css';

import App from './App';
import theme from './theme';
import store, { persistor } from './redux/store';
import { WebSocketProvider } from './WebSockets/WebSocketProvider';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { Authenticator } from '@aws-amplify/ui-react';

import { PersistGate } from 'redux-persist/integration/react';

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

Amplify.configure(awsconfig);

console.log("🧪 AWS Config at runtime:", awsconfig);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ParallaxProvider>
          <BrowserRouter>
            <HelmetProvider> 
              <WebSocketProvider>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <Authenticator.Provider>
                    <App />
                  </Authenticator.Provider>
                </LocalizationProvider>
              </WebSocketProvider>
            </HelmetProvider> 
          </BrowserRouter>
        </ParallaxProvider>
      </ThemeProvider>
    </PersistGate>
  </Provider>
);